import type { LocalData } from './types';

// Role names exactly as the backend issues them.
export const Roles = {
    Admin: 'Administrator',
    User: 'User',
    TemporaryAdminUser: 'TemporaryAdminUser',
    TemporaryInternalUser: 'TemporaryInternalUser',
    TemporaryUser: 'TemporaryUser',
} as const;

export function isAdmin(auth: LocalData | undefined): boolean {
    return !!auth && auth.isSignedin && auth.roles.includes(Roles.Admin);
}

export function isSignedIn(auth: LocalData | undefined): boolean {
    return !!auth && auth.isSignedin;
}

/** A user mid-2FA: authenticated by credentials but not yet fully signed in. */
export function isTemporaryUser(auth: LocalData | undefined): boolean {
    return (
        !!auth &&
        !auth.isSignedin &&
        (auth.roles.includes(Roles.TemporaryAdminUser) ||
            auth.roles.includes(Roles.TemporaryUser) ||
            auth.roles.includes(Roles.TemporaryInternalUser))
    );
}

/** True for AD/admin-type identities (anything beyond a plain local "User"). */
export function isAdUser(auth: LocalData | undefined): boolean {
    return !!auth && auth.roles.some((r) => r !== Roles.User);
}
